import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-root" }

import Sidebarmenu from "@/components/Sidebarmenu.vue";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardLayout',
  setup(__props) {

const route = useRoute();
const sidebar = ref();

const isEditorRoute = computed(() => {
  return route.name === 'editor' || route.path.startsWith('/editor/');
});

const toggleSidebar = () => {
  sidebar.value?.toggleSidebar();
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isEditorRoute.value)
      ? (_openBlock(), _createBlock(Sidebarmenu, {
          key: 0,
          ref_key: "sidebar",
          ref: sidebar
        }, null, 512))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["layout-content", { 'full-width': isEditorRoute.value }])
    }, [
      _createElementVNode("main", {
        class: _normalizeClass(["content", { 'editor-content': isEditorRoute.value }])
      }, [
        _createVNode(_component_router_view)
      ], 2)
    ], 2)
  ]))
}
}

})